<div class="container-filtros" style="position: relative; top: 0px; z-index: 1; padding: 1rem">
    <!--<div class="col-selected">
        <strong class="text-color-blue-primary label-title">Total : </strong>
        <strong> {{ total }}</strong>
        <strong class="text-color-blue-primary label-title"> Desde: </strong>
        <strong> {{ fechaMinimaText }}</strong>   
        <strong class="text-color-blue-primary label-title"> Hasta: </strong>
        <strong> {{ fechaMaximaText }}</strong>   
    </div>-->
    <div class="col-action">
        <div (click)="onOpenModal()" style="cursor: pointer" class="link-filtros">
            <i class="icon-hide filter"></i><strong>Filtros</strong>
        </div>
    </div>
</div>

<ng-template #contenidoModal>
    <div [class]="'filtros-busqueda' + classModal">
    <div class="content lightbox-content-show pb-2">
      <!--filtros-->
      <div class="filtros-info">
        <div class="header-container">
          <h6 class="text-title">Filtros</h6>
          <button mat-icon-button class="close-icon" (click)="onCierrenModal()">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <p class="text-descripcion">
          Aplica los filtros que encuentres necesarios para visualizar tus
          datos.
        </p>

        <div [formGroup]="formEdicion">
          <div>
            <div
              class="form-group"
              (focus)="picker.open()"
              (click)="picker.open()"
            >
              <mat-form-field appearance="fill" style="width: 100% !important">
                <mat-label>Selecciona un rango de fechas</mat-label>
                <mat-date-range-input
                  [formGroup]="range"
                  [rangePicker]="picker"
                  [max]="fechaMaxima"
                  [min]=""
                >
                  <input
                    matStartDate
                    formControlName="start"
                    placeholder="Fecha desde"
                  />
                  <input
                    matEndDate
                    formControlName="end"
                    placeholder="Fecha hasta"
                  />
                </mat-date-range-input>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker-toggle matSuffix (click)="clearDate($event)">
                  <i class="bi bi-x-lg" matDatepickerToggleIcon></i>
                </mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-error
                  *ngIf="range.controls.start.hasError('matStartDateInvalid')"
                  >La fecha inicio no es válida</mat-error
                >
                <mat-error
                  *ngIf="range.controls.end.hasError('matEndDateInvalid')"
                  >La fecha fin no es válida</mat-error
                >
              </mat-form-field>
            </div>
          </div>

          <div class="cal d-none"></div>
          
          <div class="buttons">
            <button
              type="button"
              class="btn btn-primary btn-filtrar"
              (click)="onFiltrar()"
            >
              Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--end div filtros-->
  </div>
    <ng-template></ng-template>

